import React from 'react';
import clsx from 'clsx';
import { Button } from 'semantic-ui-react';
import { newRequestUrl } from '@/constants/urls';
import { requestSources } from '@/requests/constants';
import DatasetStatusButton from './DatasetStatusButton';

const DatasetStatusButtons = ({
  accessRequestAllowed,
  accessRequestSupported,
  accessRequestUnsupportedReasons,
  className,
  code,
  cohortAllowed,
  cohortSupported,
  cohortUnsupportedReasons,
  dictionaryCode,
  name,
  hasConditions,
  icon,
  newCohort,
  newCohortCode,
  newRequestCode,
  showConditions,
  size = 'mini',
  vertical,
}) => (
  <Button.Group
    className={clsx('aridhia-status-buttons', className)}
    vertical={vertical}
    labeled={!icon}
    size={size}
    icon
    compact
  >
    {accessRequestAllowed && (
    <DatasetStatusButton
      supported={accessRequestSupported}
      reasons={accessRequestUnsupportedReasons}
      url={newRequestUrl(requestSources.DATASET, code, newRequestCode, '#')}
      status="requestable"
      icon={icon}
    />
    )}
    {hasConditions && (
    <DatasetStatusButton
      supported
      reasons={[]}
      onClick={() => showConditions(requestSources.DATASET, code, name)}
      status="conditions"
      icon={icon}
    />
    )}
    {cohortAllowed && (
    <DatasetStatusButton
      supported={cohortSupported}
      reasons={cohortUnsupportedReasons}
      onClick={() => newCohort(newCohortCode, code, dictionaryCode)}
      status="queryable"
      icon={icon}
    />
    )}
  </Button.Group>
);

export default DatasetStatusButtons;
